(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('redux'), require('connected-react-router'), require('redux-thunk'), require('history')) :
  typeof define === 'function' && define.amd ? define(['redux', 'connected-react-router', 'redux-thunk', 'history'], factory) :
  (global['kenetto-redux'] = factory(global.redux,global.connectedReactRouter,global.thunk,global.history));
}(this, (function (redux,connectedReactRouter,thunk,history) { 'use strict';

  thunk = thunk && thunk.hasOwnProperty('default') ? thunk['default'] : thunk;

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  /**
   * Store object that serves a redux store instance and a browserHistory instance
   */

  var Store = function () {
    /**
     * Creates the Store object
     * @param {string} basepath The basepath of the application
     * @param {object} reducers The reducers to be added to the store
     * @param {object} initialState The initial state of the store
     * @param {object} middlewares The middlewares to be added to the store
     */
    function Store(basepath, reducers) {
      var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var middlewares = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      classCallCheck(this, Store);

      this._history = history.createBrowserHistory({ basename: basepath });
      this._initialState = initialState;
      this._reducers = redux.combineReducers(reducers);
      var _middlewares = [thunk, connectedReactRouter.routerMiddleware(this._history)];
      if (middlewares) {
        Object.keys(middlewares).forEach(function (key) {
          return _middlewares.push(middlewares[key]);
        });
      }
      this._enhancers = redux.compose(redux.applyMiddleware.apply(undefined, _middlewares), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
        return f;
      });
    }

    /**
     * Returns a object of type {Store}
     * @returns {Store} object
     */


    createClass(Store, [{
      key: 'store',
      get: function get$$1() {
        return redux.createStore(connectedReactRouter.connectRouter(this._history)(this._reducers), this._initialState, this._enhancers);
      }

      /**
       * Returns a browserHistory object created using {createBrowserHistory} method of the {history} module
       * @returns {history} object
       */

    }, {
      key: 'history',
      get: function get$$1() {
        return this._history;
      }
    }]);
    return Store;
  }();

  var store = void 0;

  /**
   * Creates a {Store} singleton instance.
   * @param {string} basename The basepath of the application
   * @param {object} reducers The reducers to be added to the store
   * @param {object} initialState The initial state of the store
   * @param {object} middlewares The middlewares to be added to the store
   * @returns {Store} instance
   */
  function createStore(basename, reducers) {
    var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var middlewares = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    if (!store) {
      store = new Store(basename, reducers, initialState, middlewares);
    }
    return store;
  }

  return createStore;

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kenetto/kenetto-redux/dist/kenetto-redux.umd.js
// module id = 89
// module chunks = 0